/* eslint-disable no-extend-native */
import 'babel-polyfill'
import 'cropperjs/dist/cropper.css'
import 'vuelayers/lib/style.css'
import 'vuetify/dist/vuetify.min.css'
import './plugins/polyfills'

import Vue from 'vue'
import Vuetify from 'vuetify'
import VueI18n from 'vue-i18n'
import moment from 'moment'
import CKEditor from 'ckeditor4-vue'
import VueApexCharts from 'vue-apexcharts'
import VueExcelXlsx from 'vue-excel-xlsx'
import VueLayers from 'vuelayers'
import VueYoutube from 'vue-youtube'
import VueGoogleCharts from 'vue-google-charts'
import VueClipboard from 'vue-clipboard2'
import {sync} from 'vuex-router-sync'
import {register} from 'register-service-worker'
import Ads from 'vue-google-adsense'
import AdblockDetector from 'adblock-detector'

// Components
import './components'
import './plugins'

// Application imports
import App from './App'
import router from '@/router'
import store from '@/store'
import utils from '@/utils/utils.js'
import firebaseMessaging from './plugins/firebase'
import {stats} from './utils/utils'

// Vuetify locale imports (seus arquivos)
import enImport from './i18n/vuetify/en'
import ptbrImport from './i18n/vuetify/pt-br'
import esImport from './i18n/vuetify/es'
import strings from './lang/Strings'
import PremiumAlert from './plugins/premiumalert'

// Configuration
VueClipboard.config.autoSetContainer = true

if (process.env.VUE_APP_PRODUCTION === true) {
  Vue.prototype.$messaging = firebaseMessaging
}

if (AdblockDetector) {
  const userHasAdblock = AdblockDetector.detect()
  localStorage.setItem('adblock', userHasAdblock)
}

Vue.prototype.stats = stats
Vue.prototype.$moment = moment
Vue.config.productionTip = false
Vue.prototype.$eventHub = new Vue()

// --- Prepare locales defensivamente (handle `default` interop) ---
const en = (enImport && enImport.default) ? enImport.default : enImport
const ptbr = (ptbrImport && ptbrImport.default) ? ptbrImport.default : ptbrImport
const es = (esImport && esImport.default) ? esImport.default : esImport

// VueI18n setup
Vue.use(VueI18n)
const messages = {
  en: {$vuetify: {...en}, ..._.get(strings, '[1]', {})},
  pt: {$vuetify: {...ptbr}, ..._.get(strings, '[0]', {})},
  es: {$vuetify: {...es}, ..._.get(strings, '[2]', {})}
}
const i18n = new VueI18n({
  locale: 'pt', // idioma inicial
  fallbackLocale: 'en',
  messages,
})

// Vuetify 1.5 - registrar locales aqui
Vue.use(Vuetify, {
  lang: {
    // registre os objetos de tradução brutos do Vuetify (não envolva com $vuetify aqui)
    locales: {en, pt: ptbr, es},
    current: 'pt',
    // Vuetify passará algo como 'dataIterator.rowsPerPageText' — precisamos prefixar com $vuetify
    t: (key, ...params) => {
      const value = params && params.length ? params[0] : undefined
      // prefixa com $vuetify para buscar nas messages definidas no VueI18n
      return i18n.t(`$vuetify.${key}`, value)
    }
  }
})

// plugins / terceiros
Vue.use(require('vue-script2'))
Vue.use(Ads.Adsense)
Vue.use(Ads.InArticleAdsense)
Vue.use(Ads.InFeedAdsense)
Vue.use(PremiumAlert)

try {
  const user = JSON.parse(localStorage.getItem('user'))
  const shouldShowAds = user && !(
    user.gestor ||
    user.vinculado ||
    user.consultor ||
    user.pecuarista ||
    user.premium ||
    user.area_universitaria ||
    user.premiumInfinito ||
    user.permissao === 0
  )
  window.shouldShowAds = shouldShowAds
} catch (e) {
  console.error('Error parsing user data:', e)
}

Vue.use(VueClipboard)
Vue.use(VueYoutube)
Vue.use(require('vue-chartist'))
Vue.use(VueLayers, {dataProjection: 'EPSG:4326'})
Vue.use(VueGoogleCharts)
Vue.use(utils)
Vue.use(VueApexCharts)
Vue.use(VueExcelXlsx)
Vue.use(CKEditor)

// Sync store with router
sync(store, router)

// Global components
Vue.component('Loading', () => import('@/components/core/Loading.vue'))
Vue.component('PremiumContent', () => import('@/components/core/PremiumContent.vue'))
Vue.component('RightClickComponent', () => import('@/components/core/RightClickComponent.vue'))
Vue.component('apexchart', VueApexCharts)

// Vue instance (passe i18n)
const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

// --- Força o registro caso o Vuetify não tenha aplicado por algum motivo ---
Vue.nextTick(() => {
  // se por algum motivo o vuetify não trouxe pt/es, adicionamos manualmente
  if (app.$vuetify && app.$vuetify.lang) {
    const locales = app.$vuetify.lang.locales || {}
    locales.en = {...messages.en.$vuetify, ...messages.en}
    if (!locales.pt) locales.pt = {...messages.pt.$vuetify, ...messages.pt}
    if (!locales.es) locales.es = {...messages.es.$vuetify, ...messages.es}
    app.$vuetify.lang.locales = locales
    app.$vuetify.lang.current = app.$vuetify.lang.current || 'pt'
  }
})

export default app
